import React, { Component, Fragment, useState, useEffect } from 'react' ;
import { Calendar, Views, dateFnsLocalizer } from 'react-big-calendar'
import format from 'date-fns/format'
import parse from 'date-fns/parse'
import startOfWeek from 'date-fns/startOfWeek'
import getDay from 'date-fns/getDay'
const locales = {
    'en-US': require('date-fns/locale/en-US'),
}

import 'react-big-calendar/lib/css/react-big-calendar.css';
import './calendar.scss';

import { testEvents }  from './testEvents' ;

import SpinnerDiv from "../Components/SpinnerDiv";

const now = new Date()

const Event = ({ event }) => {
    return (
        <span>
      <strong>{event.title}</strong>
            {event.desc && ':  ' + event.desc}
    </span>
    )
}

const EventAgenda = ({ event }) =>
{
    return (
        <span>
      <em style={{ color: 'magenta' }}>{event.title}</em>
      <p>{event.desc}</p>
    </span>
    )
}

const customDayPropGetter = date => {
    if (date.getDate() === 7 || date.getDate() === 15)
        return {
            className: 'special-day',
            style: {
                border: 'solid 3px ' + (date.getDate() === 7 ? '#faa' : '#afa'),
            },
        }
    else return {}
}

const customSlotPropGetter = date => {
    if (date.getDate() === 7 || date.getDate() === 15)
        return {
            className: 'special-day',
        }
    else return {}
}

const localizer = dateFnsLocalizer({
    format,
    parse,
    startOfWeek,
    getDay,
    locales,
})

const CalendarKey = () =>
{
    return (
        <div className="diary-key">
            <div className="key-entry">
                <div className="key-colors green"></div>
                <div className="key-text">Not Due</div>
            </div>
            <div className="key-entry">
                <div className="key-colors blue"></div>
                <div className="key-text">Due</div>
            </div>
            <div className="key-entry">
                <div className="key-colors paleamber"></div>
                <div className="key-text">Overdue</div>
            </div>
            <div className="key-entry">
                <div className="key-colors green"></div>
                <div className="key-text">Birthdays</div>
            </div>
            <div className="key-entry">
                <div className="key-colors amber"></div>
                <div className="key-text">Annual</div>
            </div>
            <div className="key-entry">
                <div className="key-colors red"></div>
                <div className="key-text">Urgent</div>
            </div>
        </div>
    )
}

const ColoredDateCellWrapper = ({ children }) =>
    React.cloneElement(React.Children.only(children), {
        style: {
            backgroundColor: 'lightblue',
        },
    })

const MyCalendar = (props) =>
{
    const [ myEventsList, setEventList ] = useState ( [] ) ;

    useEffect(() => {
        getData();
    }, []);


    const showMore = ( slot ) =>
    {
        console.log ("Book") ;
    }

    const getDateYear = ( d ) =>
    {
        let x = d.substr(0,4) ;

        return +x ;
    }

    const getDateMon = ( d ) =>
    {
        let x = d.substr(5,2) ;

        x = +x -1  ;

        return +x;
    }

    const getDateDays = ( d ) =>
    {
        let x = d.substr(8,2) ;

        return +x ;
    }

    const getData = () =>
    {
        setEventList (testEvents);
        return;

        $.ajax({
            type: 'GET',
            url: Globals.APIFolder + '/calendar/peps',
            success:(data)=>
            {
                if ( checkError(data))
                {
                    let myEvents = data.data.map ( (element) => {

                        let applicableDate = element.pep_due_date ;

                        if ( ( element.tag == 'meeting_arranged' || element.tag ==  'post_meeting' || element.tag ==  'post_meeting_late' ) && element.meeting_date != null)
                        {
                            applicableDate = element.meeting_date ;
                        }

                        let obj = {
                            id: element.child_id,
                            title: element.firstname + ' ' + element.surname,
                            start:  new Date ( getDateYear(applicableDate), getDateMon(applicableDate), getDateDays(applicableDate)),
                            end:  new Date ( getDateYear(applicableDate), getDateMon(applicableDate), getDateDays(applicableDate)),
                        };

                        switch ( element.tag )
                        {
                            case 'due':
                                obj.bgColor = "#2793e6"
                                break ;
                            case 'not_due':
                                obj.bgColor = "#10b838"
                                break ;
                            case 'meeting_arranged':
                                obj.bgColor = "#f3d697" ;
                                break ;
                            case 'post_meeting':
                                obj.bgColor = "#10b838" ;
                                break ;
                            case 'in_review':
                                obj.bgColor = "#10b838" ;
                                break ;
                            case 'pending_action':
                                obj.bgColor = "#10b838" ;
                                break ;
                            case 'post_meeting_late':
                                obj.bgColor = "#de42b7" ;
                                break ;
                            case 'overdue_less_than_14':
                                obj.bgColor = "#e63f22" ;
                                break ;
                            case 'overdue_less_than_28':
                                obj.bgColor = "#e63f22"
                                break ;
                            case 'overdue_more_than_28':
                                obj.bgColor = "#e63f22"
                                break ;
                            case 'new_to_care':
                                obj.bgColor = "#e62309"
                                break ;
                            default:
                                obj.bgColor = '#00a0ea'
                                break ;
                        }

                        return obj;
                    })

                    setEventList(myEvents);
                }
            },
            error:function(jqXHR, textStatus, error)
            {
                handleAjaxError(jqXHR, textStatus, error) ;
            }
        });
    }

    const eventStyleGetter = (event, start, end, isSelected) =>
    {
        let backgroundColor = '#' + event.hexColor;

        if ( event.bgColor != null )
        {
            backgroundColor = event.bgColor ;
        }

        const style = {
            backgroundColor: backgroundColor,
            borderRadius: '5px',
            opacity: 0.8,
            color: 'black',
            marginLeft: '2px',
            marginRight: '2px',
            border: '0px',
            display: 'block'
        };

        return {
            style: style
        };
    }

    const onClickEvent = ( event ) =>
    {
        var returnURL = btoa(Globals.BaseURL +'/home.php?activePage=pepcalendar');

        const url =  Globals.BaseURL + '/view_child.php?activePage=peps&childid='+event.id+ '&return='+returnURL ;

        window.location = url;

    }

    if ( myEventsList.length === 0 )
    {
        return <SpinnerDiv/>
    }
    else
    {
        return (
            <Fragment>
                <div style={{padding: '20px'}}>
                    <Calendar
                        defaultView={Views.MONTH}
                        views={[Views.MONTH, Views.DAY, Views.WEEK]}
                        onShowMore = { showMore}
                        localizer={localizer}
                        events={myEventsList}
                        startAccessor="start"
                        endAccessor="end"
                        eventPropGetter={eventStyleGetter}
                        onSelectEvent={onClickEvent}
                        style={{height: 700}}
                        step={60}
                        showMultiDayTimes
                        defaultDate={new Date()}
                        components={{
                            timeSlotWrapper: ColoredDateCellWrapper,
                        }}
                    />
                    <CalendarKey></CalendarKey>
                </div>
            </Fragment>
        )
    }
}

export default MyCalendar ;
